// eslint-disable-next-line import/prefer-default-export
export enum PaymentTermsVariablesEnum {
  clientAddress = 'clientAddress',
  clientName = 'clientName',
  companyName = 'companyName',
  endDate = 'endDate',
  invoiceFrequency = 'invoiceFrequency',
  paymentTerms = 'paymentDaysTerms',
  securityDeposit = 'securityDeposit',
  sendOn = 'sendOn',
  startDate = 'startDate'
}

export enum ContractHeaderVariablesEnum {
  clientAddress = 'clientAddress',
  clientName = 'clientName',
  companyName = 'companyName',
  endDate = 'endDate',
  invoiceFrequency = 'invoiceFrequency',
  paymentTerms = 'paymentTerms',
  securityDeposit = 'securityDeposit',
  startDate = 'startDate'
}
